import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import BannerForm from "./components/form";
import BannerTable from "./components/table";
import Service from "../../services/brandCategoryService";
import ProductService from "../../services/productService";
import DateRangePicker from "../../components/common/dateRangePicker";
import Search from "../../components/common/search";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class CreateBanner extends Component {
  state = {
    infoData: [],
    page: 0,
    pageSize: 10,
    totalRecords: 0,
    loading: false,
  };
  componentWillMount() {
    console.log("-----DataTableComponent---");
    // this.setState({ infoData: data });
    // this.setState({ trainings: store.get("myCart") });
    // Service.fetchDetectedInfo().then(response => {
    //   // //console.log("response", response[0] === "{");
    //   toast.success("List fetched successfully!");
    //   // if (response[0] === "{") {
    //   //   this.setState({ infoData: [JSON.parse(response)] });
    //   // } else if (response[0] === "[") {
    //   //   this.setState({ infoData: JSON.parse(response) });
    //   // } else {
    //   //   this.setState({ infoData: [] });
    //   // }
    // });
  }
  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { bannerStatus } = params;
    this.setState({ loader: true, bannerStatus }, function () {
      this.callApiInfo();
      this.callApiProductInfo();
    });
  }
  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { bannerStatus } = params;
    if (this.state.bannerStatus !== bannerStatus) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          bannerStatus: bannerStatus,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }
  callApiInfo = () => {
    const {
      bannerStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate,
    } = this.state;
    Service.fetchBannerImagesInfo(
      undefined,
      bannerStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate
    ).then((response) => {
      if (!response.error) {
        var totalRecords = Math.ceil(response.totalRecords / pageSize);
        console.log({ response: response.data });
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response?.data?.bannerImages,
          totalRecords: totalRecords,
          imageUrl: undefined,
        });
      } else {
        this.setState({
          loader: false,
          infoData: [],
          totalRecords: 0,
          imageUrl: undefined,
        });
      }
    });
    this.setState({ loader: false });
  };
  callApiProductInfo = () => {
    ProductService.fetchProductList().then((response) => {
      if (!response.error) {
        this.setState({
          modalFormShow: false,
          loader: false,
          productList: response.productList,
        });
      } else {
        this.setState({
          modalFormShow: false,
          loader: false,
          productList: [],
        });
      }
    });
    this.setState({ loader: false });
  };
  addBannerForm = (data) => {
    const { isEdit, info, imageUrl, selectedProductId } = this.state;
    this.setState({ loader: true });
    data["imageUrl"] = imageUrl;
    data["bannerImageId"] = isEdit ? info._id : undefined;
    data["productId"] = selectedProductId;
    var method = isEdit ? "PUT" : "POST";
    Service.addBannerImageInfo(data, method).then((response) => {
      if (!response.error) {
        this.callApiInfo();
        // this.props.history.push("/dealer/inbox");
      }
      // //console.log("response", response[0] === "{");
      // toast.success("List fetched successfully!");
      // if (response[0] === "{") {
      //   this.setState({ infoData: [JSON.parse(response)] });
      // } else if (response[0] === "[") {
      //   this.setState({ infoData: JSON.parse(response) });
      // } else {
      //   this.setState({ infoData: [] });
      // }
    });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };
  onSearchText = (searchText) => {
    this.setState(
      {
        page: 0,
        searchText: searchText,
        startDate: "",
        endDate: "",
      },
      function () {
        if (searchText && searchText !== "" && searchText.length > 0) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onSearchDate = (startDate, endDate) => {
    this.setState(
      {
        page: 0,
        searchText: "",
        startDate: startDate,
        endDate: endDate,
      },
      function () {
        if (startDate && endDate) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onChangePageSize = (pageSize) => {
    this.setState(
      {
        pageSize: pageSize,
      },
      function () {
        if (pageSize) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onChangePage = (page) => {
    this.setState(
      {
        page: page,
      },
      function () {
        $.ajaxQ.abortAll();
        this.callApiInfo();
      }
    );
  };
  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeActive = (bannerImageId, value, index) => {
    console.log({ bannerImageId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    Service.onBannerImageReady(bannerImageId, value).then((response) => {
      if (!response.error) {
        infoData[index].public = value;
        this.setState({ infoData, loader: false });
        // this.props.history.push("/products/all");
      }
      this.setState({ loader: false });
    });
  };
  render() {
    const {
      bannerStatus,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
      productList,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;

    const bannerFormProps = {
      productList: productList,

      // onChangeProductId: this.onChangeProductId,
      onChangeProductId: (bannerImageId) => {
        this.setState({ selectedProductId: bannerImageId });
      },
      imageUrl: imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      info: info || {},
      active: this.state.active,
      onChangeProductUrl: (e) => {
        console.log({ e });
      },
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeBannerId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addBannerForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      // BannerForm: infoData,
    };
    const propsTable = {
      bannerStatus: bannerStatus,
      multiSelectOption: false,
      myData: infoData,
      loading: loading,
      pageSize: pageSize,
      page: page,
      totalRecords: totalRecords,
      // pageSize: infoData.length < 10 ? infoData.length : 10,
      pagination: true,
      onChangeActive: this.onChangeActive,
      onEditInfo: (index, info) => {
        this.props.history.push("/banners/" + info._id + "/update");
        // this.setState({
        //   modalFormShow: true,
        //   isEdit: true,
        //   info,
        //   imageUrl: info.imageUrl,
        // });
      },
      onChangePageSize: (pageSize) => {
        //console.log({ pageSize });
        this.onChangePageSize(pageSize);
      },
      onChangePage: (page) => {
        this.onChangePage(page);
      },
      deactivateMember: (staffMemberId) => {
        this.memberDeactivate(staffMemberId);
      },
      handleInfoEdit: (info) => {
        //console.log({info})
        this.dealerInfoEdit(info);
      },
    };
    // const propsSearchText = {
    //   searchText: this.state.searchText,
    //   onChangeText: (searchText) => {
    //     this.onSearchText(searchText);
    //   },
    // };
    return (
      <Fragment>
        <Breadcrumb title={bannerStatus} parent="Banner" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)"}}>
                {/* <div className="card-header">
                  <h5>Select Multiple Data</h5>
                </div> */}

                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}
                <div className="card-body datatable-react" style={{padding:"30px"}}>
                  <div className="row mb-2">
                    <div className="col-sm-4">
                      <Button
                        className="btn btn-danger"
                        onClick={
                          () => this.props.history.push("/banners/add")
                          // this.setState({
                          //   modalFormShow: true,
                          //   isEdit: false,
                          //   info: undefined,
                          // })
                        }
                      >
                        Add New Banner
                      </Button>{" "}
                    </div>
                    <div className="col-sm-4">
                      {/* <Search {...propsSearchText} /> */}
                    </div>

                    <div className="col-sm-4" style={{ marginTop: "10px" }}>
                      {/* <DateRangePicker {...propsDaterangePicker} /> */}
                    </div>
                  </div>
                  {/* {infoData && infoData.length > 0 && ( */}
                  <BannerTable
                    {...propsTable}
                    className="-striped -highlight"
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modalFormShow}
          toggle={() => this.onClickToggle()}
          size="lg"
          // style={{ width: "80%", maxWidth: "90%" }}
        >
          <ModalHeader toggle={() => this.onClickToggle()}>
            {isEdit ? "Update Banner info" : "Add Banner"}
          </ModalHeader>
          <ModalBody>
            <BannerForm {...bannerFormProps} />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default CreateBanner;
